'use client';

import { useEffect, useState } from 'react';
import { fetchAgbCountry } from '@/api/agb';
import type { AgbCountryData } from '@/api/types/agb';
import { useStore } from '@/providers/app-store-provider';

export function useAgbCountry(): AgbCountryData | null {
  const token = useStore((state) => state.token);
  const clientTokenReady = useStore((state) => state.clientTokenReady);
  const [result, setResult] = useState<{ token: string; data: AgbCountryData | null } | null>(null);

  useEffect(() => {
    setResult(null);
    if (!clientTokenReady) return;

    const controller = new AbortController();
    let active = true;

    // 仅保留当前页面、当前身份的数据，避免复用游客或其他账号的包邮门槛。
    fetchAgbCountry(controller.signal)
      .then((data) => {
        if (active) setResult({ token, data });
      })
      .catch(() => {
        // 网络及鉴权异常由请求层处理；失败时不回退旧的硬编码金额。
        if (active) setResult(null);
      });

    return () => {
      active = false;
      controller.abort();
    };
  }, [clientTokenReady, token]);

  return clientTokenReady && result?.token === token ? result.data : null;
}
